import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { required, length, email, acceptance } from 'redux-form-validators/lib/'
import { InputError, TextField } from '@foodsby/nutrient'
import { termsAndConditionsRoute } from '../../routes/routes'
import { noSpacesAllowed } from '../../util/validators'
import { confirmRegisterStart } from '../../redux/modules/user'
import { Submitting } from '../common/Submitting'
import Checkbox from '../common/Checkbox'

export const EmailForm = ({
  handleSubmit,
  submitting,
  pristine,
  toggleVisibility
}) => (
  <form onSubmit={handleSubmit} data-gtm-elm-id="CreateAccountForm">
    <div className="row center-xs col-xs">
      <div className="row start-xs">
        <div className="col-xs-12">
          <Field
            id="email"
            name="email"
            type="email"
            component={TextField}
            label="Email Address *"
            maxLength="254"
            validate={[required({ msg: `email is required` }), email()]}
          />
        </div>
        <div className="col-xs-12">
          <div className="col end-xs showPassword">
            <button className="link" type="button" onClick={toggleVisibility}>
              Show Password
            </button>
          </div>
          <Field
            id="confirmPassword"
            name="password"
            type="password"
            className="confirmPassword"
            component={TextField}
            label="Create Password *"
            validate={[
              noSpacesAllowed,
              required({ msg: `Password is required` }),
              length({ min: 8 })
            ]}
          />
        </div>
        <div className="col-xs-12">
          <Field
            id="AgreeToTOS"
            name="agreeToTOS"
            component={Checkbox}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                e.preventDefault()
                document.getElementById(
                  'AgreeToTOS'
                ).checked = !document.getElementById('AgreeToTOS').checked
              }
            }}
            label={
              <small>
                By signing up, you agree to our{' '}
                <a
                  style={{ display: 'inline' }}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={termsAndConditionsRoute.path}
                >
                  <small>Terms and Conditions Agreement</small>
                </a>
              </small>
            }
            validate={[
              acceptance({
                msg: `You must accept the Terms and Conditions Agreement`
              })
            ]}
          />
        </div>
        <div className="col-xs-12 center-xs login-button-container">
          {submitting ? (
            <Submitting />
          ) : (
            <button id="oneShotRegister" type="submit" disabled={submitting}>
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  </form>
)

// email form is a reduced registration form
export const EmailFormContainer = reduxForm({
  form: 'confirmregister'
})(EmailForm)

class CollectEmailPanel extends Component {
  componentDidUpdate() {
    if (
      this.props.confirmUserError &&
      document.getElementById('AgreeToTOS') != null
    ) {
      document.getElementById('AgreeToTOS').checked = false
    }
  }

  passwordVisibility() {
    let currentType = document.getElementById('confirmPassword')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }
  render() {
    const {
      confirmRegisterStart,
      locationId,
      confirmUserError,
      submitting,
      path
    } = this.props
    return (
      <div className="col-xs">
        <EmailFormContainer
          enableReinitialize
          initialValues={{ locationId }}
          onSubmit={creds => confirmRegisterStart(creds, path)}
          submitting={submitting}
          toggleVisibility={this.passwordVisibility}
        />
        {confirmUserError && (
          <InputError visible={confirmUserError && confirmUserError !== null}>
            {confirmUserError}
          </InputError>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    currentUser,
    confirmRegisterStart,
    confirmUserError,
    submitting
  } = state.user
  return {
    currentUser,
    confirmRegisterStart,
    confirmUserError,
    submitting
  }
}

const mapDispatchToProps = {
  confirmRegisterStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectEmailPanel)
